<template>
  <section v-if="!isReady || isGetRequestPending" class="drawings">
    <p-loading />
  </section>
  <section v-else class="drawings">
    <header>
      <h1>Drawings</h1>
      <section class="action-wrapper">
        <router-link v-if="$hasPermission('templates.write')" to="/drawings/create">+ new</router-link>
      </section>
    </header>

    <p-list
      name="drawings"
      :data="collection"
      :total="total"
      :metadata="{
        name: { label: 'Name', width: 'minmax(0, 3fr)' },
        description: { label: 'Description', width: 'minmax(0, 3fr)' },
        tags: { label: 'Tags', width: 'minmax(100px, 2fr)' },
        modifiedAt: { label: 'Last modification', width: '175px' }
      }"
      @edit="edit"
    >
      <template #__actions="{ item }">
        <p-button color="primary" variant="text" title="Download template" @click="download(item.contentUrl)">⤓</p-button>
        <p-button variant="text" title="Edit this drawing" @click="edit(item.id)"> &#9998;</p-button>
      </template>
    </p-list>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Button from './../common/Button';
import Loading from './../common/Loading';
import List from './../common/List';

export default {
  components: {
    'p-button': Button,
    'p-loading': Loading,
    'p-list': List
  },
  data() {
    return {
      isReady: false
    };
  },
  computed: {
    ...mapState({
      collection: s => s.drawings.collection,
      total: s => s.drawings.total,
      isGetRequestPending: s => s.drawings.isGetRequestPending
    }),
    sorted() {
      return this.collection;
    }
  },
  async created() {
    await this.$store.dispatch('drawings/getCollection');
    this.isReady = true;
  },
  methods: {
    async edit(id) {
      this.$router.push({ path: `/drawings/${id}/edit` });
    },
    download(url) {
      window.open(`/api${url}`, '_blank');
    }
  }
};
</script>

<style scoped lang="scss">
.drawings {
  display: grid;
  padding: 0 0.5rem 0 1rem;
  grid-template-columns: 1fr;
  grid-template-rows: max-content minmax(0, 1fr);
  grid-gap: 0.5rem;
  width: 100%;
  height: 100%;

  > header {
    padding: 0.5rem 0.5rem 0;
    display: flex;
    justify-content: space-between;

    box-sizing: border-box;
    h1 {
      color: var(--theme-on-surface);
      font-size: 1.5rem;
      font-weight: 700;
      margin-right: 0.25rem;
    }

    .action-wrapper {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>
